﻿import Vue from "vue";
import common from "../../common";
import context_ from "../context";
import core from "../../core";
import config_ from "./../config";
import EditVue_ from "../vue/EditVue";
import HotEditableFormAction_ from "../vue/hotEditable/HotEditableFormAction";
import utilities_ from "../utilities";
import FormService_ from "../../services/FormService";
import FormNode_ from "../vue/hotEditable/FormNode";
import SearchBox_ from "../../core/SearchBox";
import PageService_ from "../../services/PageService";

declare function require(module: string): unknown;
const context = require("../context") as typeof context_;
const config = require("./../config") as typeof config_;
const utilities = require("../utilities") as typeof utilities_;
// const FormService = require("../../services/FormService") as FormService_;
// const EditVue = require("../vue/EditVue") as EditVue_;
// const HotEditableFormAction = require("../vue/hotEditable/HotEditableFormAction") as HotEditableFormAction_;
// const FormNode = require("../vue/hotEditable/FormNode") as FormNode_;
// const SearchBox = require("../../core/SearchBox") as SearchBox_;
// const PageService = require("../../services/PageService") as PageService_;
//const jsClasses = require("../../../js/jsClasses") as any;

interface ISettings {
    /** Valeur de l'attribut HTML "name" du formulaire contenant les champs */
    formName: string;
    /** Valeur de l'attribut HTML "id" du module Vuejs */
    vueElId: string;
    /** URL de l'API qui sera appeler lors de la sauvegarde  */
    updateApiUrl: string;
    /** URL correspondant a la page precedente (doit etre definie si l'option "useBrowserHistoryToGoBackOnCancel" est activee) */
    previousPageUrl?: string;
    /** Definie si le clique du bouton Annuler ("cancel") doit faire un "Back history" ou s'il doit aller a l'API (default: true) */
    useBrowserHistoryToGoBackOnCancel?: boolean;
    /** Definie sur le mode "Edition" est constant ou s'il est "togglable" (default: false) */
    isEditionAlwaysOn?: boolean;
    /** Definie si, en mode "Edition", le formulaire doit avoir un bouton de sauvegarde ou si la sauvegarde est effectuee lors des changements de valeurs des champs (default: false) */
    liveUpdateOnEditMode?: boolean;
    liveUpdateOnEditModeIgnoredFieldNames?: string[];
    /** Permet de gerer manuellement les boutons du formulaires lors des changements de mode de formulaire (original/edition). 
     * Default: TRUE */
    disableManageButtonsOnFormModeChange?: boolean;
    /** Determine si ce web component doit etre ajoute dans la liste "main.context.components" correspondant aux components loades dans la page courrante. 
     * Default: TRUE */
    appendToContextualComponents?: boolean;
    /** Determine si le formulaire inclus doit considerer le parametre 'hotform' lorsqu'il est chage (mode 'edition' ou 'original').
     * Default: TRUE */
    loadFormModeFromUrl?: boolean;
    /** Determine si le webComponent est un embeddedContent (CollapsableForm, EmbeddedForm, etc.) */
    embeddedContentModels: common.IEmbeddedContentModel[];
    /** !!OBSOLETE!! Utiliser le 'bag' */
    customData?: common.IPostCustomData;
    concurrencySumCheck?: string;
    /** Default: TRUE */
    focusFirstFieldOnEdition?: boolean;
    searchBox?: common.ISearchBoxConfig;
    bag?: {};
    /** Configurations permettant de definir des conditions afin de caracteriser un bouton de l'attribut 'disabled' (association entre un ou des boutons, et une valeur textuelle de champs). */
    disabledButtonsByDefaultFieldConfig?: common.IHotFormDisabledButtonByDefaultFieldConfig[];
}

class DefaultEdit implements common.IWebComponent {
    private _isInit = false;
    private _formService?: FormService_;
    private _pageService?: PageService_;
    private _editVue = null as EditVue_ | null;
    private _loader = null as core.Loader | null;
    private _previousPageUrl?: string | null;
    private _vueElId?: string;
    private _updateApiUrl?: string | null;
    private _liveUpdateOnEditMode?: boolean;
    private _liveUpdateOnEditModeIgnoredFieldNames?: string[];
    private _useBrowserHistoryToGoBackOnCancel?: boolean;
    private _isEditionAlwaysOn?: boolean;
    private _confirmPopup = null as core.ConfirmationPopup | null;
    /** OBSOLETE: Utiliser le 'bag' */
    private _customData = null as common.IPostCustomData | null;
    private _disabledButtonsByDefaultFieldConfig?: common.IHotFormDisabledButtonByDefaultFieldConfig[];
    private _searchBox?: SearchBox_ | null;
    private _liveUpdate = { canPost: true, timoutId: null as ReturnType<typeof setTimeout> | null };
    onFormActionSuccessCallback = null as ((action: HotEditableFormAction_, data?: common.IHotEditableFormResponseData) => void) | null;

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        // configuration
        this._updateApiUrl = s.updateApiUrl || null;
        this._vueElId = s.vueElId || (() => { throw "La propriété 'settings.vueElId' est requise."; })();
        this._isEditionAlwaysOn = s.isEditionAlwaysOn === true;//default=FALSE
        this._liveUpdateOnEditMode = s.liveUpdateOnEditMode === true;//default is FALSE
        this._liveUpdateOnEditModeIgnoredFieldNames = s.liveUpdateOnEditModeIgnoredFieldNames || [];
        this._useBrowserHistoryToGoBackOnCancel = s.useBrowserHistoryToGoBackOnCancel !== false;//default is TRUE
        this._previousPageUrl = s.previousPageUrl || null;
        this._customData = s.customData || {};
        this._disabledButtonsByDefaultFieldConfig = s.disabledButtonsByDefaultFieldConfig || [];
        this._searchBox = s.searchBox && s.searchBox.searchBoxSettings ? new SearchBox_(s.searchBox.searchBoxSettings, s.searchBox.filtersFormName) : null;

        this._pageService = new PageService_();
        this._formService = new FormService_(s.formName);
        this._loader = new core.Loader(this._vueElId);
        this._confirmPopup = new core.ConfirmationPopup("#ActionConfirmPopup.mod-popup");

        this.setupVue(s);

        if (s.appendToContextualComponents !== false)
            context.components.add(this);

        return this;
    }
    /** OBSOLETE: Utiliser le 'bag' */
    getFromCustomData(key: string) {
        if (!key)
            throw "L'argument 'key' est obligatoire.";
        return (this._customData as any)[key];
    }
    /** OBSOLETE: Utiliser le 'bag' */
    setToCustomData(key: string, value?: any) {
        if (!key)
            throw "L'argument 'key' est obligatoire.";
        (this._customData as any)[key] = value;
        return this;
    }

    destroy() {
        this._editVue?.shared?.destroyComponentsByNode();
        this._editVue?.$destroy();
        this._editVue = null;//DESTROY (TEST)
    }
    getApiUrl() { 
        return this._updateApiUrl ?? null;
    }
    registerFormManagerParentNode(parent: FormNode_, containerFieldName: string, url: string | null) {
        if (this._editVue?.formManager?.formNode) {
            this._editVue.formManager.formNode.onRegister(containerFieldName, url, this);
            parent?.registerChildNode(this._editVue.formManager.formNode);
        }
        return this;
    }

    /** Sera appelé par le embedded field pour y injecter le navContext */
    insertNavContextHiddenField(navContextId: string) {
        utilities.insertNavContextHiddenField(this._editVue?.shared?.getFormName() ?? null, navContextId);
        return this;
    }
    // /** Sera appelé par le embedded field pour y injecter le sum check */
    // insertConcurrencySumCheckHiddenField(sumCheck: string) {
    //     utilities.insertConcurrencySumCheckHiddenField(this._editVue?.shared?.getFormName(), sumCheck);
    //     return this;
    // }
    refreshEmbeddedComponents() {
        if (this._editVue)
            this._editVue?.refreshEmbeddedComponents();
    }
    private setupVue(s: ISettings) {

        Vue.prototype.$initialData = {
            vueElId: this._vueElId,
            formName: s.formName,
            bag: s.bag || null,
            loadFormModeFromUrl: s.loadFormModeFromUrl !== false,
            embeddedContentModels: s.embeddedContentModels || null,
            includesConcurrencySumCheck: true,
            concurrencySumCheck: s.concurrencySumCheck || null,
            currentCulture: context.culture.name
        };

        this._editVue = new EditVue_().setOnCultureChangeCallback((culture: common.Cultures) => {
            context.components.getPage().changeCulture(culture);
        });

        if (s.disableManageButtonsOnFormModeChange === true)
            this._editVue?.setManageButtonsOnFormModeChange(false);

        this._editVue?.shared?.setActionCallback((a: HotEditableFormAction_) => {
            this.onFormAction(a);
        }).setErrorCallback((errors: common.IError[], config?: common.IHotEditableFormConfig) => {
            this.onFormActionError(errors, null, config);
        });
        this._editVue?.shared?.setupForm(this._isEditionAlwaysOn, s.focusFirstFieldOnEdition);
    }

    private onFormAction(action: HotEditableFormAction_) {
        if (this._formService?.actionHasError(action))
            return;

        utilities.disabledHotEditableButtonsByConfigurations(this._disabledButtonsByDefaultFieldConfig, this._editVue?.formManager);

        const isEditionFormMode = action.isEditionFormMode();
        const actionValue = action.getActionValue();
        var actionType = action.getActionType();

        if (isEditionFormMode && this._liveUpdateOnEditMode) {
            if (this._liveUpdate.canPost) {
                this._liveUpdate.canPost = false;
                if (this._liveUpdate.timoutId)
                    clearTimeout(this._liveUpdate.timoutId);
                this._liveUpdate.timoutId = setTimeout(() => {
                    this._liveUpdate.canPost = true;
                }, config.liveUpdateMode.minDelayMsBetweenTwoAction);
            }

            else return;

            const isExcluded = utilities.any(this._liveUpdateOnEditModeIgnoredFieldNames, x => x === action.getFieldName());
            if (isExcluded)
                return;
            else if (actionType === common.HotEditableActionTypes.unknown)
                actionType = common.HotEditableActionTypes.update;
        }

        if (isEditionFormMode && actionType === common.HotEditableActionTypes.unknown)
            return;

        if (actionType === common.HotEditableActionTypes.cancel && this._useBrowserHistoryToGoBackOnCancel && this._previousPageUrl) {
            utilities.redirect(this._previousPageUrl);
            return;
        }

        const post = () => {
            this._formService?.validateAndPost(
                this._updateApiUrl,
                null,
                {
                    posted_actionType: actionType,
                    posted_actionValue: actionValue,
                    posted_formName: this._editVue?.shared?.getFormName(),
                    posted_fieldName: action.getFieldOrButtonName(),
                    posted_currentCulture: context.culture.get(),
                    posted_currentUrl: utilities.currentUrl(),
                    posted_previousPageUrl: this._previousPageUrl,
                    posted_customData: utilities.ensureCustomDataIsValid(this._customData),
                    posted_currentEmbeddedComponentName: this._editVue?.shared?.getCurrentEmbeddedComponentName(),
                    posted_bag: this._editVue?.getBagRaw(),
                    posted_isControlClick: action.getButtonClickContext().isCtlClick === true
                } as common.IHotEditableFormPostArguments,
                (data: common.IHotEditableFormResponseData) => {
                    this.onFormActionSuccess(action, data);
                },
                (e: any, config: any) => {
                    this.onFormActionError(e, action, config);
                });
        };

        if (this._liveUpdateOnEditMode)
            // NOTE: ajout d'un delai afin de permettre aux plugins de se mettre a jour.
            setTimeout(() => {
                post();
            }, 100)
        else
            post();

        // if (this._editVue?.shared?.hasEditionEmbeddedForm())
        //     this.getConfirmPopup().show("Attention", "Un autre formulaire est en cours de modification. En poursuivant cette opération, tout changements apportés précédemment seront annulés. Êtes-vous certain de vouloir continuer?", post);
        // else
        //     post();
    }

    private onFormActionSuccess(action: HotEditableFormAction_, data?: common.IHotEditableFormResponseData) {
        data = data || {};

        const actionType = action.getActionType();
        const actionValue = action.getActionValue();
        const isButtonClick = action.isButtonClick();
        const isEditionFormMode = action.isEditionFormMode();
        const isUpdateAction = actionType === common.HotEditableActionTypes.update;
        const isDeleteAction = !isUpdateAction && actionType === common.HotEditableActionTypes.delete;
        const showMessages = data.disableAllMessages !== true;
        const showAutoSuccessMessages = showMessages && data.disableAutomaticMessages !== true;
        const buttonClickContext = action.getButtonClickContext();
        const changedFieldName = action.getFieldName();

        if (data.outdatedContent)
            return this._pageService?.applyOutdatedContent(data, this._editVue);

        if (data.scrollToTopOnSuccess)
            // Scroll to top
            setTimeout(() => { utilities.scrollToTop(375, '.mp-content'); }, 125);

        // Doit etre ouvert avant le refresh du widget si une URL de fichier typiquement en target=blank
        const openRedirectUrlInBlankPage = data.redirectUrl && utilities.openInBlankPage(data.redirectUrlOptions);
        if (openRedirectUrlInBlankPage)
            utilities.redirectWithDelay(data.redirectUrl, 1, true);

        const displayCustomMessage = (immediateDisplay: boolean, text: string, name?: string, messageType?: common.MessageTypes, autoClose?: boolean) => {
            messageType = messageType || common.MessageTypes.success//<- default is success
            if (this._editVue?.shared)
                if (!this._editVue.shared.displayMessage(name, text, messageType))
                    this._formService?.displayMessage(text, messageType, immediateDisplay, autoClose);
        }

        if (!this._editVue?.shared) {
            //debugger;
            console.warn("[UPA] 'EditVue' already disposed.");
            return;
        }

        var succesMessageSended = false;
        if (this._editVue?.shared?.isHotEmbeddedComponent()) {
            // Widgets -> brothers
            if (data.refreshBrotherEmbeddedComponents)
                this._editVue?.refreshBrotherEmbeddedComponents();
            else if (data.restoreBrotherEmbeddedComponents)
                this._editVue?.restoreBrotherEmbeddedComponents();
            else if (data.ensureBrotherEmbeddedComponentsIsDefaultUrl)
                this._editVue?.ensureBrotherEmbeddedComponentsIsDefaultUrl();
            // Widgets -> all
            if (data.hotEmbeddedComponentsToUpdate?.length) {
                if (showMessages) {
                    const updateCurrentEmbededForm = utilities.any(data.hotEmbeddedComponentsToUpdate, x => !x.name);
                    if (updateCurrentEmbededForm && data.messages?.length) {
                        for (let i = 0; i < data.messages.length; i++) {
                            const m = data.messages[i];
                            const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                            displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                        }
                        // if (!this._editVue?.shared?.displayMessage(data.messageName, data.messages, customMessageType))
                        //     this._formService?.displayMessage(data.messages, customMessageType, false, true);
                    } else if (showAutoSuccessMessages && !succesMessageSended) {
                        this._formService?.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);
                        succesMessageSended = true;
                    }
                }

                if (this._editVue.shared.updateHotEmbeddedComponents(data.hotEmbeddedComponentsToUpdate))
                    return;
            }
        }

        if (isDeleteAction)
            if (utilities.autoRedirect(data, this._previousPageUrl))
                return;

        this._editVue?.shared?.updateConcurrencySumCheck(data.updatedConcurrencySumCheck);
        this._editVue?.updateBag(data.bag);

        const repost = () => this._editVue?.shared?.applyUpdate(actionValue, actionType, isButtonClick, buttonClickContext, changedFieldName);
        if (FormService_.confirm(
            this._editVue?.formManager?.getFormName(),
            this._confirmPopup,
            data?.confirmationMessages,
            () => {
                // Accepted
                repost();
            },
            (returnToApiOnDenied: boolean) => {
                // Denied

                if (returnToApiOnDenied) {
                    repost();
                    return;
                }

                if (this._editVue?.shared?.confirmationRejected())
                    this._formService?.displayNotSavedErrorMessageImediately();
            }))
            return;

        if (data.fieldsToUpdate)
            for (let i = 0; i < data.fieldsToUpdate.length; i++) {
                const updatedField = data.fieldsToUpdate[i];
                if (updatedField)
                    this._editVue?.shared?.updateFieldFromApi(updatedField);
            }

        if (isUpdateAction || data.redirectUrl) {
            const url = data.redirectUrl || this._previousPageUrl || null;
            if (url) {
                if (showMessages)
                    if (data.messages?.length) {
                        for (let i = 0; i < data.messages.length; i++) {
                            const m = data.messages[i];
                            const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                            displayCustomMessage(false, m.text, m.name, m.messageType, ac);
                        }

                        // if (!this._editVue?.shared?.displayMessage(data.messageName, data.messages, customMessageType))
                        //     this._formService?.displayMessage(data.messages, customMessageType, false, true);
                    } else if (showAutoSuccessMessages && !succesMessageSended) {
                        this._formService?.displaySuccessMessageFromAction(action, false, true, this._liveUpdateOnEditMode);
                        succesMessageSended = true;
                    }

                if (!openRedirectUrlInBlankPage)
                    // Ne pas rouvrir une seconde fois l'url en target=blank
                    utilities.redirectWithOptions(url, data.redirectUrlOptions);

                return;
            }
        }

        if (showMessages)
            if (data.messages?.length) {
                for (let i = 0; i < data.messages.length; i++) {
                    const m = data.messages[i];
                    const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                    displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                }
                // if (!this._editVue?.shared?.displayMessage(data.messageName, data.messages, customMessageType))
                //     this._formService?.displayMessage(data.messages, customMessageType, true, true);
            }
            else if (showAutoSuccessMessages && !succesMessageSended) {
                this._formService?.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);
                succesMessageSended = true;
            }

        if (isEditionFormMode && !this._isEditionAlwaysOn && !this._liveUpdateOnEditMode)
            this._editVue?.shared?.setAsHotEditableFormMode();
    }

    private onFormActionError(errors: common.IError[], action?: HotEditableFormAction_ | null, config?: common.IHotEditableFormConfig) {
        config = config || {};

        for (let i = 0; i < errors.length; i++) {
            const error = errors[i];

            if (error.code !== 110) {

                if (context.env.currentIsDev || context.env.currentIsLocal) {
                    utilities.printError(error.message + ' (code: ' + error.code + ')');
                    this._formService?.displayErrorImediately(new core.Error("Une erreur système est survenue et est affichée dans la console du navigateur.", error.code));
                }
                else
                    this._formService?.displayErrorImediately(new core.Error(error.message));

                return;
            }

            if (config.disableAutomaticMessages)
                return;

            // Functional
            const fieldFound = this._editVue?.shared?.displayFieldError(this._editVue?.shared?.getFormName(), error, true);
            if (fieldFound) {
                this._formService?.displayNotSavedErrorMessageImediately();
                return;
            }

            this._formService?.displayErrorImediately(new core.Error(error.message));
        }
    }
    drawTreeNodes() {
        this._editVue?.formManager?.formNode?.drawTree();
        return "..end of tree.";
    }
}

export = DefaultEdit;